import { TaskType } from '../../../../../main/types/asset/asset.enums.ts';

import { BALL_ANIMATION_DEFAULT_DURATION_SECONDS } from '../../../../constants/ball.ts';
import { SAYING_SOUNDS_LESSON_TASK_TYPES } from '../../../../types/task.types.ts';

import { AppSaySoundBaseHandler } from './app-say-sound-base.handler.ts';

/**
 * Handler for app sound out tasks (when the app/critter sounds out words phoneme by phoneme)
 * Used in various tasks including WordReading, Rhyming, and SayTheSoundsReview
 *
 * This specialized handler focuses on sequential phoneme playback with controlled timing
 */
export class AppSoundOutStateChangeHandlerUtil extends AppSaySoundBaseHandler {
  private static _instance: AppSoundOutStateChangeHandlerUtil;

  static get instance(): AppSoundOutStateChangeHandlerUtil {
    if (!AppSoundOutStateChangeHandlerUtil._instance) {
      AppSoundOutStateChangeHandlerUtil._instance = new AppSoundOutStateChangeHandlerUtil();
    }
    return AppSoundOutStateChangeHandlerUtil._instance;
  }

  // Implement abstract methods from base class
  protected getHandlerName(): string {
    return 'AppSoundOut';
  }

  protected async playAudio(): Promise<void> {
    // Always speak the step
    await this.audioPlayerUtil.speakStep();

    // Play parts if the task is one of the saying sounds tasks
    const shouldPlayParts = await this.isOneOfTasks(SAYING_SOUNDS_LESSON_TASK_TYPES);
    if (shouldPlayParts) {
      await this.audioPlayerUtil.speakStepParts();
    }

    // Play pronunciation if the task is not SayTheSoundsReview
    const shouldPlayPronunciation = !(await this.isOneOfTasks([TaskType.SayTheSoundsReview]));
    if (shouldPlayPronunciation) {
      await this.audioPlayerUtil.speakPronunciation();
    }
  }

  protected calculateAnimationDuration(duration: number): number {
    // Use seconds multiplied by 1000 for word phonemes
    return (duration === 0 ? BALL_ANIMATION_DEFAULT_DURATION_SECONDS : duration) * 1000;
  }
}

export const getAppSoundOutStateChangeHandlerUtil = (): AppSoundOutStateChangeHandlerUtil =>
  AppSoundOutStateChangeHandlerUtil.instance;
